// extracted by mini-css-extract-plugin
export default {"home-main":"Contact_home-main__utREw","home_title":"Contact_home_title__89kOG"};